<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> SUBIR IMAGENS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="material.id"
          >{{ material.id }} -
          {{ material.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <!-- <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn> -->
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="collection"
                :items="collections"
                item-text="name"
                item-value="id"
                label="Coleção"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="provider"
                :items="providers"
                label="Fornecedor"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                hide-details
                dense
                outlined
                @change="handleChangeProvider"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="12">
              <v-card max-width="1200">
                <v-card-text>
                  <!-- <div class="text--primary"></div> -->
                  <!-- <div class="text--primary"></div> -->
                  <div class="text--primary">
                    <v-row>
                      <v-col cols="8">
                        <p class="title">Regras para arquivos:</p>
                        Formato: <b>1920x1080</b>
                        <br />
                        Tamanho: <b>Até 500kb</b>
                        <br />
                        Nome do arquivo: 4 primeiros digitos é o código de
                        fornecedor + referencia do produto + Material + Cor +
                        Sequencial
                      </v-col>
                      <v-col cols="4">
                        <p class="title">Exemplos:</p>
                        <ul>
                          <li>0001_1234567_VAQUILHONA_BLACK_001.PNG</li>
                          <li>0001_1234567_VAQUILHONA_BLACK_002.PNG</li>
                          <li>0001_1234567_CERVIATTO_BROWN_001.PNG</li>
                          <li>0001_1234567_CERVIATTO_TAN_001.PNG</li>
                        </ul>
                        <!-- <br />
                        <br />
                        .PNG<br />
                        .PNG -->
                      </v-col>
                    </v-row>
                  </div>
                  <!-- <div class="text--primary">
                    
                  </div> -->
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-file-input
                v-model="fileupload"
                label="Adicionar Arquivos"
                outlined
                dense
                required
                multiple
                :disabled="provider == ''"
                counter
                show-size
                @change="onFilePicked"
                accept="image/*"
                prepend-icon="mdi-camera"
              ></v-file-input>
              <!-- <v-btn color="green darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-upload</v-icon> Adicionar Arquivos
              </v-btn> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Nome</th>
                      <th class="text-left">Tamanho</th>
                      <th class="text-left">Resolução</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in photos" :key="item.id">
                      <td>{{ item.name }}</td>
                      <td>{{ formatBytes(item.size) }}</td>
                      <td>{{ item.width }} x {{ item.height }}</td>
                      <td>
                        <v-chip
                          v-if="item.status == true"
                          dark
                          label
                          color="green"
                          >Aprovado</v-chip
                        >
                        <v-tooltip left v-else color="#ff0000">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                              label
                              dark
                              >Reprovado</v-chip
                            >
                          </template>
                          <label>{{ item.statusText }}</label>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-icon
                          @click="handleDeletePhoto(item)"
                          color="red darken-1"
                          >mdi-delete</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="3"
              ><span>
                Imagens Aprovadas:
                <b>{{
                  photos.filter((item) => item.status === true).length
                }}</b></span
              >
              <br />
              <v-btn
                color="green darken-3"
                dark
                class="mt-5"
                @click="validate()"
              >
                <v-icon left>mdi-upload</v-icon> Subir Imagens
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as MaterialAPI from "@/api/requests/MaterialRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    material: {
      id: "",
      code: "",
      name: "",
      status: 1,
    },
    fileupload: null,
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    provider: "",
    providers: [],
    collection: "",
    collections: [],
    photos: [],
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      // if (this.$route.params.id) {
      //   this.getMaterial(this.$route.params.id);
      // }
      this.getCollections();
      this.getProviders();
    },
    async getMaterial(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.material = await MaterialAPI.getById(id);
      } catch (error) {
        this.material = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getCollections() {
      // this.showLoading();
      this.loading = true;
      try {
        this.collections = await CollectionAPI.getAll();
      } catch (error) {
        this.collections = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getProviders() {
      // this.showLoading();
      this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.providers = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.providers = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Material" });
    },
    validate() {
      let form = new FormData();
      this.photos.map((item) => {
        form.append("photos[]", item.File);
      });
      form.append("collection", this.collection);
      form.append("provider", this.provider);
      this.post(form);
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        let res = await fetch(`${URL}photo-galery`, {
          method: "POST",
          body: data,
        });
        if (res.status < 300) {
          alert("Salvo com sucesso");
          this.$router.push({ name: "HistoryUpload" });
        } else {
          res = await res.json();
          throw new Error(res.message);
        }
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    onFilePicked(files) {
      // this.photos = files;
      // console.log(this.photos);
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.$set(this.photos, i, {
          id: i,
          File: file,
          name: file.name,
          size: file.size,
          width: 0,
          height: 0,
          status: true,
          statusText: "",
        });
        // this.photos[i] = ;
        this.getSizeImage(file, i);
      }
    },
    getSizeImage(file, index) {
      let fr = new FileReader();
      let that = this;

      fr.onload = function () {
        let img = new Image();

        img.onload = function () {
          that.photos[index].width = img.width;
          that.photos[index].height = img.height;
          that.validatePhoto(index);
        };

        img.src = fr.result; // is the data URL because called with readAsDataURL
      };

      fr.readAsDataURL(file);
    },
    validatePhoto(index) {
      let providerSelected = this.providers.find(
        (item) => item.id === this.provider
      );
      // for (let index = 0; index < this.photos.length; index++) {
      const photo = this.photos[index];
      if (photo.name.slice(0, 4) !== providerSelected.code) {
        this.photos[index].status = false;
        this.photos[index].statusText =
          "Nome da foto inválida para esse Fornecedor";
      } else if (photo.size > 1024 * 500) {
        this.photos[index].status = false;
        this.photos[index].statusText = "Tamanho maior que 500kb";
      } else if (photo.width !== 1920) {
        this.photos[index].status = false;
        this.photos[index].statusText = "Resolução diferente de 1920x1080";
      } else if (photo.height !== 1080) {
        this.photos[index].status = false;
        this.photos[index].statusText = "Resolução diferente de 1920x1080";
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    handleChangeProvider() {
      this.photos = [];
      this.fileupload = null;
    },
    handleDeletePhoto(item) {
      let photoCopy = [...this.photos];
      let index = photoCopy.findIndex((photo) => photo.id === item.id);
      this.$delete(photoCopy, index);
      this.photos = [...photoCopy];
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
